export const compararChavesObjetos = (obj1: any, obj2: any) => {
    const arrPrimeiroObj = Object.keys(obj1).map(key => key.toLowerCase())
    const arrSegundoObj = Object.keys(obj2).map(key => key.toLowerCase())

    const arrFinal = arrPrimeiroObj.filter(key => {
        return arrSegundoObj.includes(key)
    })
    return arrFinal.length === arrPrimeiroObj.length && arrFinal.length === arrSegundoObj.length
}